export function LinearNoteAdd({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.96711 15V10.8334M9.99998 12.9167H5.83332M6.66665 1.66669V4.16669M13.3333 1.66669V4.16669M13.175 2.85002C15.9583 2.95002 17.3667 3.97502 17.45 7.89169L17.5583 13.0334C17.625 16.4667 16.8333 18.1917 12.6667 18.2834L7.66665 18.3834C3.49998 18.4667 2.63332 16.7667 2.56665 13.3417L2.44998 8.19169C2.36665 4.27502 3.74165 3.19169 6.50832 2.98335L13.175 2.85002Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
